import { core as coreDomain } from '@/config';

import { createHttpClient } from './createHttpClient';

export const publicBaseInstance = createHttpClient({ baseURL: coreDomain, isWithoutAuth: true });
export const authBaseInstance = createHttpClient({ baseURL: coreDomain });
export const authBetProcessor = createHttpClient({ baseURL: `${coreDomain}/api/sportsbook` });
export const authLeaderboard = createHttpClient({ baseURL: `${coreDomain}/api/leaderboard` });
export const authContent = createHttpClient({ baseURL: `${coreDomain}/api/content` });
